import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { Modal as RBModal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { activeModals } from 'src/reducers/modalSlice';

import ModalBody from './ModalBody';
import ModalFooter from './ModalFooter';
import ModalHeader from './ModalHeader';
import useConfirmationModal from './useConfirmationModal';
import useModal from './useModal';

const Modal = () => {
	const [isOnTop, setIsOnTop] = useState(true);
	const [confirmModalOpen, setConfirmModalOpen] = useState(false);

	const modalsActive = useSelector(activeModals);
	const { maxWidth, title, onClose, type, tagConfig } = useModal();

	useEffect(() => {
		if ((modalsActive ?? []).length > 1) {
			if (modalsActive[modalsActive.length - 1].type === type) {
				setIsOnTop(true);
				return;
			}
			setIsOnTop(false);
		} else {
			setIsOnTop(true);
		}
	}, [modalsActive, type]);

	useEffect(() => {
		if (confirmModalOpen) {
			confirmAction(() => onClose());
		}
	}, [confirmModalOpen]);

	const [confirmAction, confirmationModal] = useConfirmationModal(() => {
		setConfirmModalOpen(false);
	});

	return (
		<>
			{confirmationModal}

			<RBModal
				id={`kt_modal_${title}`}
				tabIndex={-1}
				onEscapeKeyDown={(e) => {
					e.preventDefault();
					setConfirmModalOpen(true);
				}}
				aria-hidden
				dialogClassName={clsx(`modal-dialog modal-dialog-centered ${maxWidth}`, { 'modal-invisible': !isOnTop })}
				style={{ zIndex: confirmModalOpen ? 1000 : 1100 }}
				show
				onHide={() => {
					setConfirmModalOpen(true);
				}}
				backdrop={modalsActive}
			>
				<ModalHeader tagConfig={tagConfig} />
				<ModalBody border />
				<ModalFooter />
			</RBModal>
		</>
	);
};

export default Modal;
